<script lang="ts">
    import { getContainer } from '$components/Context/ContainerContext';
    import ButtonCtaInner from '$components/ServicePage/ButtonCtaInner.svelte';
    import type { ButtonCtaProps } from '$components/ServicePage/utils';

    const currentUser = getContainer().currentUserStore().currentUser();

    export let cta: ButtonCtaProps;
</script>

<ButtonCtaInner
    class={cta.class ?? ''}
    href={cta.href}
    text={cta.text}
    icon={cta.icon}
    subject={cta.subject}
    to={cta.to}
    withCompanyNameRequired={cta.withCompanyNameRequired}
    withPhoneRequired={cta.withPhoneRequired}
    messagePlaceholder={cta.messagePlaceholder}
    modalTitle={cta.modalTitle}
    defaultRelatedCategoryId={cta.relatedCategoryId}
    currentUser={$currentUser}
/>
